import { Validator } from "@angular/forms";
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Injectable } from "@angular/core";

@Injectable()
export class PhoneValidator implements Validator {

    maskContainer: { mask: Array<RegExp | string> | ((string) => Array<RegExp | string>) }

    constructor() {
    }

    public validate(control: AbstractControl): ValidationErrors {

        if (!control.value || !this.maskContainer || !this.maskContainer.mask)
            return null;

        const mask: Array<RegExp | string> = typeof this.maskContainer.mask === 'function' ?
            this.maskContainer.mask(control.value) : this.maskContainer.mask;

        let regExpStr = mask.map(v => {
            if (v instanceof RegExp) {
                let item = v.toString();
                item = item.substr(item.indexOf("/") + 1, item.lastIndexOf("/") - 1);

                return item.endsWith('?') ? item : item + "{1}";
                // return item.substr(item.indexOf("/\") + 1, item.lastIndexOf(\"/\") - 1) + \"{1}\";
            }
            else if (v == ' ') {
                return ("[\\\" + v + \"]{1}");
            }
            else {
                return (`${v}{1}`);
            }
            
        }).join("");

        if (!new RegExp("^" + regExpStr + "$").test(control.value)) {
            return { "phoneformat": true };
        }
        return null
    }

    public registerOnValidatorChange(fn: () => void): void {
    }
}